import type {
  Action,
  Threshold,
  DataRoute,
  Dependency,
  PublicId,
  SchemaInstance,
  WorkflowProps,
} from '../../engine/types';
import { sanitizeImportedActions } from '../helpers';
import type { WorkflowState } from '../state';
import type { Snapshot, SnippetMode, SnippetOperation } from '../types';

export function setSnippetMode(
  state: WorkflowState,
  action: {
    payload: {
      mode: SnippetMode | null;
    };
  },
) {
  const { mode } = action.payload;
  state.ui.snippet.mode = mode;
}

export function setSnippetActiveOperation(
  state: WorkflowState,
  action: {
    payload: {
      operation: SnippetOperation | null;
      snippetActionPublicId?: PublicId | null;
    };
  },
) {
  const { operation, snippetActionPublicId } = action.payload;
  state.ui.snippet.activeOperation = {
    operation,
    snippetActionPublicId,
  };
}

export function setPreSnippetWorkflowDataSnapshot(
  state: WorkflowState,
  action: {
    payload: {
      snapshot: Snapshot<Partial<SchemaInstance>> | null;
    };
  },
) {
  const { snapshot } = action.payload;
  state.ui.snippet.preSnippetWorkflowDataSnapshot = snapshot;
}

export function setPreSnippetWorkflowPropsSnapshot(
  state: WorkflowState,
  action: {
    payload: {
      snapshot: Snapshot<WorkflowProps> | null;
    };
  },
) {
  const { snapshot } = action.payload;
  state.ui.snippet.preSnippetWorkflowPropsSnapshot = snapshot;
}

export function setSnippetIncompatibleActions(
  state: WorkflowState,
  action: {
    payload: {
      actions: Action[];
    };
  },
) {
  const { actions } = action.payload;
  state.ui.snippet.incompatibleActions = actions;
}

export function setSnippetMetadata(
  state: WorkflowState,
  action: {
    payload: WorkflowState['snippet']['metadata'];
  },
) {
  state.snippet.metadata = action.payload;
}

export function setSnippetPreviewData(
  state: WorkflowState,
  action: {
    payload: {
      actions: Record<string, Action>;
      thresholds: Record<string, Threshold>;
      dataRoutes: Record<string, DataRoute>;
      dependencies: Record<string, Dependency[]>;
      workflowToken: string;
      name: string;
      publicVersion: number;
    };
  },
) {
  state.workflowData = {
    ...state.workflowData,
    actions: sanitizeImportedActions(action.payload.actions, state.workflowProps.allWorkflows),
    thresholds: action.payload.thresholds,
    dataRoutes: action.payload.dataRoutes,
    dependencies: action.payload.dependencies,
    validations: {
      timestamp: Date.now(),
      actions: [],
    },
    token: action.payload.workflowToken,
    name: action.payload.name,
    publicVersion: action.payload.publicVersion,
  };
}
